import React, { useState, useEffect } from 'react';
import CommunityProfileCard from './CommunityProfileCard';
import { getSearchCreators } from '../../../Services/ShowsApi';
import { useSelector } from 'react-redux';
import { updateConnects, getUserProfile } from '../../../Services/ShowsApi';
import { API_STATUS, SEARCH_TYPE } from '../../../utils/constant';
import { useDispatch } from 'react-redux';
import { setValue, setSearchUserData } from '../../../redux/valueSlice';
import { setProfileShow } from '../../../redux/notificationSlice';
import { Pagination } from '@mui/material';
import { useLoader } from '../../../Components/LoaderContext';
import BeatLoader from 'react-spinners/BeatLoader';
import ToggleTypeSelector from '../../../Components/ToggleTypeSelector';

const CommunitySearch = () => {
    const dispatch = useDispatch();
    const value = useSelector((state) => state?.value);
    const [searchType, setSearchType] = useState('Podcaster');
    const [searchData, setSearchData] = useState([]);
    const [page, setPage] = useState(1);
    const limit = 9; // fixed limit per page
    const [totalPages, setTotalPages] = useState(1); // total number of pages
    const { triggerLoader, hideLoader } = useLoader();
    const [beatLoader, setBeatloader] = useState(true)

    const fetchData = async () => {
        setBeatloader(true)
        try {
            const filterType = searchType === 'Podcaster' ? 'podcasters' : 'topics';
            const filterValue = value?.filterValue || "";

            if (filterValue) {
                const { data } = await getSearchCreators(filterType, filterValue, page, limit);
                const { Data, totalCount } = data?.body;
                setBeatloader(false)
                setSearchData(Data);
                setTotalPages(Math.ceil(totalCount / limit)); // assuming you receive totalCount
            }
        } catch (error) {
            console.error("Error fetching search:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [searchType, page, value, value?.searchPageLoad]);

    const handleClickViewProfile = async (creater) => {
        triggerLoader("Loading profile...")
        const res = await getUserProfile(creater?.UserID);
        if (res.status == API_STATUS.success) {
            const { body } = res.data;
            const { Data } = body;
            dispatch(setValue({ viewSearchProfile: true, viewFromRequests: false }));
            dispatch(setSearchUserData(Data[0]));
            dispatch(setProfileShow(true));
        }
        hideLoader();
    };

    const handleConnectionClick = async (userID) => {
        const data = {
            SenderID: localStorage.getItem("user_id"),
            ReceiverID: userID,
        };
        const res = await updateConnects(data);
        if (res.status == API_STATUS.success) {
            fetchData();
        }
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleSearchTypeChange = (type) => {
        setSearchType(type);
        setPage(1); // Reset page when search type changes
    };

    function UpdateLoader() {
        return (
            <div className="profile-sweet-loading" style={{ display: "flex", alignItems: "center", gap: "1vh" }}>
                <span>Fetching users, please wait...</span>
                <BeatLoader
                    color="rgba(41, 104, 254, 0.8)"
                    loading={true}
                    size="1.5vh"
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        );
    }

    return (
        <div className='community_search_container'>
            <div className='community_search_type'>
                <ToggleTypeSelector TYPE_Items={SEARCH_TYPE} handleSearchTypeChange={handleSearchTypeChange} toggleType={searchType}/>
                {/* <div className='community_search_type_selecter'>
                    {SEARCH_TYPE?.map(({ id, type }) => (
                        <React.Fragment key={id}>
                            <div
                                className={`community_search_type_item pointer ${searchType === type ? "selected_Type" : ""}`}
                                onClick={() => handleSearchTypeChange(type)}
                            >
                                <span>{type}</span>
                            </div>
                            {id !== SEARCH_TYPE.length - 1 && <div className='search_type_separator'></div>}
                        </React.Fragment>
                    ))}
                </div> */}
            </div>

            {searchData?.length > 0 ? (
                <div className='community_searchresult'>
                    <div className='community_searchr_cards'>
                        {searchData.map((item, index) => (
                            <div key={index} className='community_searchr_cards_container'>
                                <CommunityProfileCard
                                    userConnection={false}
                                    creater={item}
                                    handleClickViewProfile={handleClickViewProfile}
                                    handleConnectionClick={handleConnectionClick}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className='community_searchresult_container_message'>
                    {beatLoader ? (
                        <UpdateLoader />
                    ) : (
                        "Sorry, no results found. Please try refining your search or adjusting the filters !!"
                    )}
                </div>
            )}
            {
                searchData?.length > 0 && (
                    <div className="community-pagination-container" style={{ display: 'flex', justifyContent: 'center', margin: '2vh 0' }}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </div>
                )
            }
        </div >
    );
};

export default CommunitySearch;
